import React from "react";
import Prof1 from "../assets/img/Prof1.jpg";
import Prof2 from "../assets/img/Prof2.jpg";
import Prof3 from "../assets/img/Prof3.jpg";

export default function ParishAdmin() {
  const clergy = [
    {
      img: Prof1,
      name: "Rev. Fr. Henry Jerome SJ",
      role: "Parish Priest",
      affiliation: "Society of Jesus (Jesuits)",
      contact: "Parish Administration & Pastoral Care"
    },
   /* {
      img: Prof2,
      name: "Rev. Fr. Joe Livingston SJ",
      role: "Assistant Parish Priest",
      affiliation: "Society of Jesus (Jesuits)",
      contact: "Youth Ministry & Liturgy Coordination"
    },*/
    {
      img: Prof3,
      name: "Rev. Fr. Benito Arulselvan SJ",
      role: "Assistant Parish Priest",
      affiliation: "Society of Jesus (Jesuits)",
      contact: "Catechesis & Substation Pastoral Ministry"
    }
  ];

  return (
    <section id="parish-admin" className="clergy-section py-5">
      <div className="container py-4">
        {/* Section Heading */}
        <div className="section-heading-wrapper text-center mb-5">
          <div className="eyebrow-badge">
            <i className="fas fa-cross"></i>
            <span>Pastoral Leadership</span>
          </div>
          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy)" }}>
            Parish Administration & Clergy
          </h2>
          <div className="cross-ornament">
            <i className="fas fa-cross"></i>
          </div>
          <p style={{ maxWidth: "700px", margin: "0 auto", color: "var(--cathedral-text-secondary)" }}>
            Under the pastoral guidance of the Jesuit Fathers (Society of Jesus), our parish priests shepherd the cathedral community in spiritual renewal, sacramental life, and active charity.
          </p>
        </div>

        {/* Clergy Cards Grid */}
        <div className="row g-4 justify-content-center">
          {clergy.map((priest, i) => (
            <div key={i} className="col-12 col-md-6 col-lg-4">
              <div className="clergy-card d-flex flex-column">
                <div className="clergy-img-wrapper">
                  <img src={priest.img} alt={priest.name} />
                </div>
                <div className="clergy-body flex-grow-1 d-flex flex-column justify-content-between">
                  <div>
                    <span className="clergy-role-tag">{priest.role}</span>
                    <h3 className="clergy-name">{priest.name}</h3>
                    <p className="clergy-society">{priest.affiliation}</p>
                  </div>
                  <div className="mt-3 pt-3 border-top" style={{ borderColor: "#eee5d4" }}>
                    <small style={{ color: "#607286", fontSize: "0.82rem" }}>
                      <i className="fas fa-briefcase text-secondary me-1"></i>
                      {priest.contact}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Parish Office Advisory Card */}
        <div className="mt-5 p-4 rounded-4" style={{ background: "#ffffff", border: "1px solid #ebdcb7", boxShadow: "0 4px 18px rgba(27, 58, 107, 0.05)" }}>
          <div className="row align-items-center g-3">
            <div className="col-lg-8">
              <h5 style={{ fontFamily: "'Playfair Display', serif", color: "var(--cathedral-navy)", marginBottom: "6px" }}>
                <i className="fas fa-church text-secondary me-2"></i> Parish Office & Pastoral Counseling
              </h5>
              <p className="mb-0" style={{ color: "var(--cathedral-text-secondary)", fontSize: "0.92rem", lineHeight: 1.6 }}>
                For certificates (Baptism, Confirmation, Marriage), Mass intentions, house blessings, or spiritual counseling, please visit the Parish Office during office hours: <strong>Mon - Sat: 9:30 AM - 1:00 PM & 4:30 PM - 7:00 PM</strong>.
              </p>
            </div>
            <div className="col-lg-4 text-lg-end">
              <a href="tel:+919176155356" className="btn-cathedral-primary" style={{ fontSize: "0.88rem", padding: "10px 22px" }}>
                <i className="fas fa-phone-alt me-2"></i> Call Parish Office
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
